var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sai-bar"},[_c('span',{staticClass:"sai-bar-fill",style:({width: _vm.progress + '%'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }